<template>
  <b-form-select
    v-model="modelValue"
    :options="options"
    :state="state"
    :disabled="!category"
    placeholder="Subtipo da instituição..."
  />
</template>

<script>
import { mapActions } from "vuex";
import { modelValue } from "@/mixins/modelValue";
import { safeArray } from "@/helpers/functions/ArrayHelpers";
import { deepCopy } from "@/helpers/functions/ObjectHelpers";

export default {
  mixins: [modelValue("value", "input")],
  data: () => ({
    instituicoes: [],
  }),
  props: {
    state: {
      type: [Boolean, null],
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    category: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    options() {
      const allOptions = safeArray(deepCopy(this.instituicoes))
        .filter((item) =>
          this.category
            ? this.category === item.categoria_instituicao_id
            : false
        )
        .map((item) => ({
          text: item.nome,
          value: item.id,
        }));

      allOptions.unshift({
        text: "Subtipo da instituição...",
        value: null,
        disabled: true,
      });

      return allOptions;
    },
  },
  methods: {
    ...mapActions("tipos_instituicoes", ["ActionFind"]),
  },
  async created() {
    try {
      const response = await this.ActionFind({ per_page: 100 });
      this.instituicoes = response.data;
    } catch (error) {}
  },
};
</script>

<style></style>
